import { use, useEffect, useState } from 'react';
import style from './get_udid.module.css'
import styles from '../views/pages/PaymentForm.module.css';
import { wait } from '@testing-library/user-event/dist/utils';

import classNames from "classnames";


const AppModal = ({showModalApp, setShowModelApp, t, apps, udid, certId, showNotification}) => {
    const [selectedApp, setSelectedApp] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    function closeModal() {
            setShowModelApp(false)
        }
 
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeModal();
        }
    });
    useEffect(() => {

    })

    async function delay(l) {
    return new Promise((resolve) => {
        setTimeout(() => { resolve(); }, l);
    });
    }  
    async function confirmAppSelection() {
        const requestBody = { 
            id: certId, 
            udid: udid,
            app_id: selectedApp
        }
        setIsLoading(true)
        
        try {  

                showNotification('Подпись началась! Не выходите с страницы до ее завершения')
                const response = await fetch(`https://cert.ipa.su/signer`, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody)
                });
        
                if (!response.ok) {
                    await delay(5000)
                    showNotification('Подпись началась! Не выходите с страницы до ее завершения')
                    setIsLoading(false)
                    return {}
                }
                showNotification('Подпись прошла успешно! Не выходите с страницы вас переведет на сайт установки')
                setIsLoading(false)
                const data = await response.json()
                await delay(2000)

                if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initDataUnsafe && window.Telegram.WebApp.initDataUnsafe.user){
                    window.Telegram.WebApp.openLink(data.url)
                } else {
                    window.location.href = data.url
                }

                return data
                } catch (error) {
                    await delay(5000)
                    showNotification('Подпись не удалась! Попробуйте чуть позже')
                    setIsLoading(false)
                    return {}
                }
        

    }

    return ( 
    <div id="app-selector-extended" className={classNames(style.modal, showModalApp ? style.show: '')}>
        <div className="modal-content">
        <div className="modal-color">
            <button className="close-btn" onClick={closeModal}>&times;</button>
            <div className="modal-header">
                <h2><i className="fas fa-signature"></i>{t("select_app")}</h2>
                <p>{t("select_sign_app")}</p>

            </div>
            
            <div className="app-selector">
                {apps.map((app) => (
                <div className={classNames("app-option", selectedApp === app.id ? 'selected': '')} onClick={() => setSelectedApp(app.id)}>
                    <i className="fas fa-edit"></i>
                    <h4>{app.name}</h4>
                </div>
                ))}
                
                
            </div>
              
            <div className="confirm-selection">
                <button className="confirm-btn" id="confirm-extended" onClick={() => confirmAppSelection()} disabled={selectedApp === null || isLoading} >
                    
                    {isLoading ? (
                        <>
                        <div className={styles.loader} style={
                            {marginRight: '5px'}
                            }></div>
                        Идет подпись...
                        </>
                    ) : (
                        <>
                        <i className="fas fa-check"></i>
                        Подтвердить выбор
                        </>
                    )}

                </button>
            </div>
        </div>
        </div>
    </div>
    )
}

export default AppModal